import { Badge as InnerBadge } from './badge';
import { BadgeContainer } from './badge-container';
const Badge = InnerBadge;
Badge.Container = BadgeContainer;
export default Badge;
